import { Injectable } from '@angular/core';
import { FormArray } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { NotifyService } from '@fry/lib/utils';

import { TranslationFormService } from './translation-form.service';


@Injectable()
export class TranslationFormStore {
  private readonly _translationConfig$ = new BehaviorSubject<any>(null);
  private readonly _translationForm$ = new BehaviorSubject<FormArray>(null);

  readonly translationConfig$ = this._translationConfig$.asObservable();
  readonly translationForm$ = this._translationForm$.asObservable();

  docType: string;
  objectId: string;
  languageCode: string;

  constructor(
    private notify: NotifyService,
    private translationFormService: TranslationFormService
  ) {
    this.translationConfig$.pipe(
      filter(translationConfig => translationConfig !== null)
    ).subscribe(translationConfig =>
      this.translationForm = this.translationFormService.getForm(translationConfig)
    );
  }

  private get translationConfig(): any {
    return this._translationConfig$.getValue();
  }

  private set translationConfig(value: any) {
    this._translationConfig$.next(value);
  }

  private get translationForm(): FormArray {
    return this._translationForm$.getValue();
  }

  private set translationForm(value: FormArray) {
    this._translationForm$.next(value);
  }

  initialize(docType: string, objectId: string, languageCode: string) {
    this.docType = docType;
    this.objectId = objectId;
    this.languageCode = languageCode;

    this.translationFormService.getSections$(this.docType, this.objectId, this.languageCode).subscribe(
      sections => this.translationConfig = this.translationFormService.parseSections(sections)
    );
  }

  save() {
    this.translationFormService.saveSections$(this.docType, this.objectId, this.languageCode, this.translationConfig, this.translationForm.value).subscribe(
      sections => {
        this.notify.success($localize `Successfully saved`);
        this.translationConfig = this.translationFormService.parseSections(sections);
      },
      error => {
        this.notify.error(error);
      }
    );
  }
}
